import { useMemo } from "react";

import { useTenantId } from "src/contexts/global/ApolloSettingsContext";
import { tenantRoleNamesFactory } from "src/services/auth";

/**
 * Resolves tenant-scoped role names for the current tenant.
 *
 * @example
 *   const designRoles = useTenantRoleNames(TENANT_ROLE_RESOURCES.DESIGN);
 *   // designRoles.ADMIN === "DTA-{currentTenantId}"
 *
 * @param {string} resource - one of TENANT_ROLE_RESOURCES
 * @returns {Record<string, string>}
 */
const useTenantRoleNames = (resource) => {
  const tenantId = useTenantId();
  return useMemo(() => {
    if (!tenantId) return {};
    return tenantRoleNamesFactory(tenantId)(resource);
  }, [tenantId, resource]);
};

export default useTenantRoleNames;
